import * as actionTypes from '../actions/ActionTypes';

function initState() {
    return {
        isLoading: false,
        loadersCount: 0
    };
}

const initialState = initState();
const startLoading = (state) => {
    return {
        ...state,
        isLoading: true,
        loadersCount: state.loadersCount + 1
    };
};
const finishLoading = (state) => {
    const newCount = state.loadersCount - 1;
    const stillWaitingOtherComponent = newCount !== 0;
    return {
        ...state,
        isLoading: stillWaitingOtherComponent,
        loadersCount: newCount,
        previousText: !stillWaitingOtherComponent ? state.text : '',
        text: !stillWaitingOtherComponent ? null : state.text
    };
};

const setText = (state, action) => {
    return {
        ...state,
        text: action.payload.text,
        previousText: action.payload.previousText || (state.text === null ? state.previousText : state.text)
    };
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.START_LOADING:
            return startLoading(state);
        case actionTypes.FINISH_LOADING:
            return finishLoading(state);
        case actionTypes.SET_LOADING_TEXT:
            return setText(state, action);
        default:
            return state;
    }
};

export default reducer;
